module.exports = __webpack_public_path__ + "static/media/learn.eb3445e0.png";